import React,{useState, useEffect} from 'react';
import TablaGeneral from './TablaGeneral'
import {useHistory} from "react-router-dom";
import {Box, IconButton, Button, Select,Typography,
  Card,TextField, LinearProgress, FormControl, InputLabel, MenuItem} from "@material-ui/core";
import IntervaloSelect from './IntervaloTabla';
import SearchIcon from '@material-ui/icons/Search';
import CardPerfil  from './CardPerfil';
import CardTotal from './CardTotal';
//import ContenedorMapa from './ContenedorMapa';
import MapDelegacion from '../MapaEdo';
import axios from "axios";
import qs from "qs";
import {ErrorGeneral, llamaApiCargaToken, llamadaApiToken} from "../funciones/ClienteAxios";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { obtenDispo } from '../funciones/IdDispositivo';
//import MapaGPS from '../MapGeneral';
import moment from 'moment';
import CardPreguntas from './CardPreguntas';
import MapaLeafComuna from './MapaLeafComuna';
import MapaLeafDistrito from './MapaLeafDistrito';
import ModalTabGeneral from './ModTabGeneral';
import ModalPerfilv2 from '../nvoPerfil/NvoPerfilv3';
import ModalNvoPerfilImg from '../nvoPerfil/ModalNvoPerfImg';
import ModalAvisoPerfil from '../nvoPerfil/ModalAvisoPerfil';
import ModalAvanceUsuario from './ModAvUsuario';
import { findNumberCad } from '../funciones/FindNumber';

const GeneralInicio = () => {
  let history = useHistory();
  const cadena = localStorage.getItem("Operacion")+"|"; 
  const idusu = localStorage.getItem("UsuId") ? parseInt(localStorage.getItem("UsuId")):0;
  const usuTitu = localStorage.getItem("usuTitu")?parseInt(localStorage.getItem("usuTitu")) :0
  const source = axios.CancelToken.source();
  const [fSelect, setFSelect] = useState({inicio:new Date(),final:new Date()});
  const auxDispV =obtenDispo()
  //const[totalPerfil,setTotalPerfil]= useState({Valido:0,Pendiente:0,Rechazado:0});
  const [totalPerfil, setTotalPerfil]= useState([]);
  const [actualizar,setActualizar]=useState(true);
  const [cargaComuna,setCargaComuna]=useState(false);
  const [cargaMapEncuesta, setCargaMapEncuesta]=useState(false);
  const [cargaDistrito,setCargaDistrito]=useState(false);
  const [cargaTotal,setCargaTotal]=useState(false);
  const [modalTabla,setModalTabla]=useState(false);
  const [arregloColor, setArregloColor] = useState([])  
  const [listTotal, setListTotal]=useState([])  
  const [modalNvoPerfil, setModalNvoPerfil] = useState(false);
  const [modalAvisoImg2, setModalAvisoImg2] = useState(false);
  const [nvoRegisPerfil, setNvoRegisPerfil] = useState([]);
  const [modalNvoImg, setModalNvoImg] = useState(false);  
  const [modalAvisoImg, setModalAvisoImg] = useState(false);
  const [modalAvUsuario, setModalAvUsuario] = useState(false);
  const [cargaList, setCargaList]=useState(false)  
  const [nombre, setNombre]=useState("")
  const [filtro, setFiltro]=useState({edo:"",TipoUsu:"",muni:"", geoEdo:"", geoMun:"", geoSecc:"", })
 
  const [listGeoEdo, setListGeoEdo]=useState([]);
 
  const [listMapComuna, setListMapComuna]=useState([]);
  const [listMun, setListMun]=useState([]);
  const [listPlantilla,setListPlantilla]=useState([])
  const [listMapDet, setListMapDet]=useState([])
  const [listReferente, setListReferente]=useState([]);
  const [referente, setReferente]=useState([]);
  //const [listMapDistrito, setListMapDistrito]=useState([]);
  const [totalSecc, setTotalSecc] = useState([])  
  const [dtoRegistro, setDtoRegistro] = useState([])  
  const [bandera,setBandera]= useState(false)  
  const [contadorTotal, setContadorTotal] = useState(0)  
  const {edo,  }=filtro

  useEffect(() => {    
    if(usuTitu===1){
 
      getListPlantilla()
      getListMapComuna()
 
      getListTotal()
    }
    return () => {
      source.cancel();
    }
  }, [])

    useEffect(()=>{
      if (nvoRegisPerfil.length!==0 &&!modalAvisoImg2 && !modalNvoImg ) {
        setTimeout(() => {    
          setModalNvoImg(true);     
         //setModalAvisoImg(true)
        }, 500);  
      }
      
    },[nvoRegisPerfil])   
 
  useEffect(()=>{
    setListMapComuna([])
    setDtoRegistro([]) 
    setListMapDet()
    setBandera(false)
  },[fSelect])

  function abrirModalNvoPerfilImg(){          
    setTimeout(() => {          
      setModalNvoImg(true);    
  }, 300);
  }

  const getListMapComuna = () => {
    const fInicio=moment(fSelect.inicio).format("YYYY-MM-DD");
    const fFinal=moment(fSelect.final).format("YYYY-MM-DD");  
    const data = qs.stringify({
      Usuario:idusu, Estado:process.env.REACT_APP_EDO, 
      FIni:`${fInicio}T00:00:00`,
      FFin:`${fFinal}T23:59:59`,
      ip:"127.0.0.0", idDispositivo: auxDispV,
    });
    const url = "lugar/v1/municipio/distrito/mapa";
    //const url = "lugar/municipio/comuna/mapa"; 
    function respuesta(auxiliar) {
      if (auxiliar.length !== 0 &&auxiliar[0].distrito ) {
        let nvoarr=[]
        auxiliar[0].distrito.forEach((element,index )=> {
          let auxGPS=[]
          element.gps.forEach((ruta)=>{
            auxGPS.push({Ln: ruta.Ln, Lt: ruta.Lt })
          })
          if (index<16) {
          nvoarr.push({ DtCol:element.DtCol, DtId: element.DtId,
            DtLat: element.Lt, DtLon: element.Ln, DtNom:element.DtNom,
            gps:auxGPS})  
          }
          
        });
        //console.log(nvoarr);
        
        return setListMapComuna(nvoarr)
      }
    }

    llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setCargaComuna, history, source);
  }

/*   const getListMapDistrito = () => {
    const data = qs.stringify({
      Usuario:idusu, Estado:process.env.REACT_APP_EDO, 
      ip:"127.0.0.0", idDispositivo: auxDispV,
    });
    const url = "lugar/municipio/distrito/mapa";

    function respuesta(auxiliar) {
      if (auxiliar[0].Id !== -1) {
        
        return setListMapDistrito(auxiliar)
      }
    }

    llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setCargaDistrito, history, source);
  } */

  function getListPlantilla()  {            //plantilla/v2/active
    const url= `plantilla/v2/active`;                            
    const data = qs.stringify({                
        usuario:idusu,          
        // dominio:process.env.REACT_APP_Dominio,                                         
        idDispositivo:auxDispV,
    });
                
    function respuesta (aux) 
    {  if (aux[0].Id !==  -1 ) 
      {  //console.log(aux);  
        setListPlantilla(aux)               
      }                                                                   
    }
    llamadaApiToken(data, url, respuesta, ErrorGeneral, history, source);
  }; 
  
  const getListMapDet = (  dtoReg) => {
    const fInicio=moment(fSelect.inicio).format("YYYY-MM-DD");
    const fFinal=moment(fSelect.final).format("YYYY-MM-DD");  
    //console.log(fInicio,fSelect2.inicio);
    
    const data = qs.stringify({
      usuario:idusu, estado:process.env.REACT_APP_EDO,       
      status:0,
      municipio:process.env.REACT_APP_MUN,
      distrito:dtoReg,
      cadena:"",
      fini:`${fInicio}T00:00:00`,
      ffin:`${fFinal}T23:59:59`,
      ip:"127.0.0.0", idDispositivo: auxDispV,
    });
    const url = "perfil/v1/distrito/lista";

    function respuesta(auxiliar) {
     // changeBandera2(true) 
      if (auxiliar[0].Id !== -1) {
      //  console.log(fInicio,fSelect2.inicio);
         setListMapDet(auxiliar)
      }
      
    }

    llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setCargaMapEncuesta, history, source);
  }

  const getListTotal = () => {
    const fInicio=moment(fSelect.inicio).format("YYYY-MM-DD");
    const fFinal=moment(fSelect.final).format("YYYY-MM-DD");      
    const data = qs.stringify({
      Usuario:idusu, Edo:process.env.REACT_APP_EDO, Muni:process.env.REACT_APP_MUN,
      FIni:`${fInicio}T00:00:00`,FFin:`${fFinal}T23:59:59`,

      ip:"127.0.0.0", idDispositivo: auxDispV,
    });
    const url = "perfil/v2/adm/dashboard/det";
 
    function respuesta(auxiliar) {
      if (auxiliar[0].Id !== -1) {        
         const auxArr=auxiliar[0].total[0]
        setContadorTotal(auxArr.GenBinario + auxArr.GenHombre + auxArr.GenMujer)
        return setListTotal(auxArr)
      }
    }

    llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setCargaTotal, history, source);
  }
 
  const generarLista = e =>{   
    e.preventDefault()    
    getListTotal()
    setTotalPerfil([])    
    setArregloColor([])
    setActualizar(!actualizar)    
    setFiltro({...filtro,geoEdo:'', })
    getListMapComuna() 
 
  }
  
  const onChange = e => {
    setNombre( e.target.value)
  }
 
  const changeBandera=()=>{
    setBandera(!bandera)
  } 

  
  const changeBandera2=(aux)=>{
    setBandera(aux)
  }

  const modalAvance = modalAvUsuario ? <ModalAvanceUsuario setModalAbierto={setModalAvUsuario} modalAbierto={modalAvUsuario} titulo="" fSelect={fSelect} /> :null
  const modNvoPerf = modalNvoPerfil && listPlantilla.length!== 0 ? 
                                  <ModalPerfilv2 modalAbierto={modalNvoPerfil} setModalAbierto={setModalNvoPerfil} 
                                    titulo="Nueva Encuesta"  listPlantilla={listPlantilla}
                                    setModalAvisoImg={setModalAvisoImg2} setNvoRegisPerfil={setNvoRegisPerfil}
                                  />:null
  const modNvoImg = modalNvoImg  && listPlantilla.length!== 0  ? 
                                  <ModalNvoPerfilImg modalAbierto={modalNvoImg} setModalAbierto={setModalNvoImg} 
                                    titulo= {nvoRegisPerfil.Nom ? "Encuesta "+nvoRegisPerfil.Nom:"Encuesta"}  auxPerfImg={listPlantilla}
                                    nvoRegisPerfil={nvoRegisPerfil} actualizar={actualizar} setActualizar={setActualizar}
                                  />:null                                       
  const modNvoAviso = modalAvisoImg  ? <ModalAvisoPerfil modalAbierto={modalAvisoImg} setModalAbierto={setModalAvisoImg} 
                                        titulo="Validación" abrirModImg={abrirModalNvoPerfilImg} 
                                        actualizar={actualizar} setActualizar={setActualizar}
                                      />:null 
  const modTablaGeneral = modalTabla ? <ModalTabGeneral setModalAbierto={setModalTabla} modalAbierto={modalTabla} titulo={"Lista de Encuestas"} 
                                        fSelect={fSelect} actualizar={actualizar} setActualizar={setActualizar}
                                        setTotalPerfil={setTotalPerfil} setArregloColor={setArregloColor}
                                        setListMun={setListMun} listMun={listMun} listReferente={listReferente}
                                        nombre={nombre} edo={edo} setListGeoEdo={setListGeoEdo}
                                        contadorTotal={contadorTotal} setTotalSecc={setTotalSecc}  listPlantilla={listPlantilla}                                       
    /> :null
  return(
  <div>
    {modalAvance}
    {modNvoPerf}
    {modNvoImg}
    {modTablaGeneral}
    {modNvoAviso}
    <Box display={'flex'} pb={1}>
      <Box mr={1} >       
        <Button onClick={generarLista} style={{width:"7rem", marginTop:".5rem", backgroundColor:process.env.REACT_APP_Btn_Color}}  
          variant="contained"  color="primary"  startIcon={<SearchIcon/>} >   
          Buscar     
        </Button>                                                                                                                        
      </Box>     
      <Box display={"flex"}>
        <IntervaloSelect fSelect={fSelect}  setFSelect={setFSelect} />              
      </Box>
      <Box >   
        <Button onClick={()=>{setModalNvoPerfil(true)}} style={{width:"13.5rem", marginTop:".5rem", marginLeft:".5rem", backgroundColor:process.env.REACT_APP_Btn_Color}}  
          variant="contained"  color="primary"  startIcon={<AddCircleOutlineIcon/>} >   
          Agregar Encuesta     
        </Button>                                                                                                                        
      </Box>  
      <Box >   
        <Button onClick={()=>{setModalTabla(true)}} style={{width:"8rem", marginTop:".5rem", marginLeft:".5rem", backgroundColor:process.env.REACT_APP_Btn_Color}}  
          variant="contained"  color="primary"  >   
          Listado     
        </Button>                                                                                                                        
      </Box>
      {/* findNumberCad("|41|",cadena)?  
      <Box >   
        <Button onClick={()=>{setModalAvUsuario(true)}} style={{width:"13rem", marginTop:".5rem", marginLeft:".5rem", backgroundColor:process.env.REACT_APP_Btn_Color}}  
          variant="contained"  color="primary"  >   
          Avance por Usuario     
        </Button>                                                                                                                        
      </Box>
      :null  */ }
    </Box>   

    <Box display={"flex"}>       
      {listTotal.length !== 0 ? 
        <Box mr={2}>
          <CardTotal valor={listTotal} dtoRegistro={dtoRegistro} />
        </Box>          
      :null}
      {listTotal.length !== 0 ? 
        <CardPerfil listTotal={listTotal} dtoRegistro={dtoRegistro} />
      :null}   
    
    </Box>
    <Box display={"flex"}>       
      {listTotal.length !== 0 ? 
        <Box mr={2}>
          <CardPreguntas listTotal={listTotal} dtoRegistro={dtoRegistro} />
        </Box>          
      :null}     
    {/*      <Button onClick={()=>setBandera(!bandera)}>mapa</Button> */}
    </Box>
    <Box display={"flex"} flexDirection={"row"}>
      <Box  style={{height:"37rem",width:"40rem"}}>
        {listMapComuna.length !==0 ?
          <MapaLeafComuna lista={listMapComuna} setDtoRegistro={setDtoRegistro}  changeBandera={changeBandera}
            getListMapDet={getListMapDet} setListMapDet={setListMapDet} fSelect={fSelect}
          />
        :cargaComuna?<Box width={"40rem"} mt={4}><LinearProgress/> </Box>:
        null}
      </Box>
      <Box  style={{height:"37rem",width:"40rem", marginLeft:"1rem"}}>
        {listMapComuna.length !==0 && dtoRegistro.length!==0 && listMapDet.length!==0 && bandera?
          <MapaLeafDistrito lista={listMapComuna} dtoRegistro={dtoRegistro} listMapDet={listMapDet} />
        :cargaMapEncuesta ? <Box width={"40rem"} mt={4}><LinearProgress/> </Box>:
        null}
      </Box>
    </Box>

  </div>
  );
};

export default GeneralInicio;